import React, { Component } from 'react';
import { Button, Form, Header, Segment } from 'semantic-ui-react';
import CoursesTable from '../../Exams/CoursesTable';
import { ToastContainer } from 'react-toastify';
import axios from 'axios';
import CourseExamsStatistic from './CourseExamsStatistic';
import {
    additionalFilterSectionStyle,
    requiredFilterSectionStyle
} from '../../StudentsReports/reportUiHelpers';


class ConstReportsByAcademicYear extends Component {
    constructor(props) {
        super(props);

        this.state = {
            data: [],
            excelData: [],
            report: 1,
            academicYear: null,
            orgUnit: null,

            activePage: 1,
            postsPerPage: 20,
            currentPosts: [],
            studyProgramBasics: [],
            studyProgramBasicId: null,
            reportRequested: false,

            orgUnitFilter: !!((localStorage.getItem('activeRole').substr(0, 10) !== 'Studentska' && localStorage.getItem('activeRole').substr(0, 19) !== 'Prodekan za nastavu')),


        };

        this.getAcademicYears = this.getAcademicYears.bind(this);
        this.handleInputChange = this.handleInputChange.bind(this);
    }
    componentDidMount() {
        let activeRole = localStorage.getItem('activeRole');
        if (localStorage.getItem('orgUnit')) {
            this.setState({ orgUnit: parseInt(localStorage.getItem('orgUnit')) });
            localStorage.setItem('activeRole', activeRole);
        }

        if (localStorage.getItem('orgUnit')) {
            let orgUnit = localStorage.getItem('orgUnit');
            window.localStorage.clear();
            localStorage.setItem('orgUnit', orgUnit);
            localStorage.setItem('activeRole', activeRole);
        }
        localStorage.setItem('activeRole', activeRole);
        this.getAcademicYears();

        if (this.state.orgUnitFilter && !localStorage.getItem('orgUnit')) {
            return;
        }

        let obj = {};
        axios.post(this.state.orgUnitFilter ? `study-programs/basic/${localStorage.getItem('orgUnit')}` : 'study-programs/basic', { ...obj })
            .then(res => {
                const studyProgramBasics = res.data.map((el) => ({
                    ...el,
                    value: el.studyProgramBasic.id,
                    key: el.studyProgramBasic.id,
                    text: el.studyProgramBasic.name + (el.studyProgramBasic.comment !== null ? ' (' + el.studyProgramBasic.comment + ')' : ''),
                    description: this.state.orgUnitFilter ? el.organizationalUnit.name : el.studyProgramBasic.studyCycles.length ? el.studyProgramBasic.studyCycles[0].displayName : ''
                })).filter(e => e.studyProgramBasic.archived === false);

                this.setState({ studyProgramBasics });
            })
            .catch(err => {
                console.log('Failed to fetch study program basics. ', err);
            });
    }

    getAcademicYears() {
        axios.get('/academic-years/current-and-previous/')
            .then(res => {
                this.setState({
                    academicYears: res.data.map(el => ({
                        ...el, key: el.id, value: el.id, text: el.name
                    })).reverse(),
                });
                // this.setState({ academicYear: this.state.academicYears[0].value });
                localStorage.setItem('academicYear', this.state.academicYear);
            });
    }

    handleInputChange(event, { name, value }) {
        if (name === 'orgUnit') {
            this.setState({ studyProgramBasicId: null, data: [], excelData: [], reportRequested: false });
            let obj = {};
            axios.post(`study-programs/basic/${value}`, { ...obj })
                .then(res => {
                    const studyProgramBasics = res.data.map((el) => ({
                        ...el,
                        value: el.studyProgramBasic.id,
                        key: el.studyProgramBasic.id,
                        text: el.studyProgramBasic.name + (el.studyProgramBasic.comment !== null ? ' (' + el.studyProgramBasic.comment + ')' : ''),
                        description: this.state.orgUnitFilter ? el.organizationalUnit.name : el.studyProgramBasic.studyCycles.length ? el.studyProgramBasic.studyCycles[0].displayName : ''
                    })).filter(e => e.studyProgramBasic.archived === false);

                    this.setState({ studyProgramBasics });
                })
                .catch(err => {
                    console.log('Failed to fetch study program basics. ', err);
                });
        }
        if (name === 'academicYear' || name === 'studyProgramBasicId') {
            this.setState({ data: [], excelData: [], reportRequested: false });
        }
        this.setState({
            [name]: value
        });
    }

    getData(studyProgramBasicId, academicYear = this.state.academicYear) {
        if (!academicYear || (this.state.orgUnitFilter && !this.state.orgUnit)) {
            this.setState({ loader: false });
            return;
        }

        this.setState({ loader: true, reportRequested: true });
        axios.get(this.state.orgUnitFilter ? `/exams/course-statistics-for-admin/${academicYear}/${this.state.orgUnit}/${studyProgramBasicId}`
            : `/exams/course-statistics/${academicYear}/${studyProgramBasicId}`)
            .then(res => {
                this.setState({
                    loader: false,
                    data: res.data.map(el => ({ ...el, averageGrade_: el.averageGrade !== null ? el.averageGrade : '' })),
                    excelData: res.data.map(el => ([
                        { value: el.courseBasicName },
                        { value: el.professor },
                        { value: el.numberOfStudentsOnCourse },
                        { value: el.numberOfDistinctStudentGradedActivities },
                        { value: el.numberOfExamRegistrations },
                        { value: el.numberOfDistinctStudentsWhoAccessedExam },
                        { value: el.numberOfStudentsWhoAccessedExam },
                        { value: el.numberOfStudentsWhoPassed },
                        { value: el.averagePassedStudentsOnCourse },
                        { value: el.averagePassedDistinctStudentGradedActivities },
                        { value: el.averagePassed },
                        { value: el.numberOfFs },
                        { value: el.numberOfEs },
                        { value: el.numberOfDs },
                        { value: el.numberOfCs },
                        { value: el.numberOfBs },
                        { value: el.numberOfAs },
                        { value: el.numberOfIOs },
                        { value: el.numberOfNONPs },
                        { value: el.numberOfNPs },
                        { value: el.numberOfNAs },
                        { value: el.numberOfZs },
                        { value: el.numberOfNZs },
                        { value: el.numberOfNOs },
                        { value: el.numberOfUOs },
                        { value: el.averageGrade !== null ? el.averageGrade : '' },
                    ]))
                });
                console.log('data', this.state.data);
            })
            .catch(err => {
                console.log('Failed to fetch course pass rate by academic year.', err);
                this.setState({ loader: false, data: [], excelData: [], reportRequested: true });
            });
    }

    render() {
        const {
            academicYear, data, loader, reportRequested
        } = this.state;
        return (
            <div>
                <Form>
                    <Segment style={requiredFilterSectionStyle}>
                        <Header as="h4" color="blue">Obavezni parametri</Header>
                        <Form.Group widths="equal">
                            {this.state.orgUnitFilter && <Form.Field>
                                <Form.Dropdown
                                    clearable
                                    label="Organizaciona jedinica"
                                    placeholder="Organizaciona jedinica"
                                    value={this.state.orgUnit}
                                    onChange={this.handleInputChange}
                                    name="orgUnit"
                                    options={this.props.organizationalUnits}
                                    search
                                    fluid
                                    selection
                                    error={this.state.organizationalUnitEntityError}
                                />
                            </Form.Field>}
                            <Form.Field>
                                <label>Akademska godina</label>
                                <Form.Dropdown
                                    placeholder="Odaberite akademsku godinu"
                                    value={this.state.academicYear}
                                    onChange={this.handleInputChange}
                                    name="academicYear"
                                    options={this.state.academicYears}
                                    search
                                    fluid
                                    selection
                                    disabled={this.state.orgUnitFilter && !this.state.orgUnit}
                                />
                            </Form.Field>
                            <Form.Field />
                        </Form.Group>
                    </Segment>

                    <Segment style={additionalFilterSectionStyle}>
                        <Header as="h4" color="blue">Dodatni filteri</Header>
                        <Form.Group widths="equal">
                            <Form.Field>
                            <Form.Dropdown
                                label="Studijski program"
                                clearable
                                placeholder="Odaberite studijski program"
                                options={this.state.studyProgramBasics}
                                onChange={this.handleInputChange}
                                name="studyProgramBasicId"
                                value={this.state.studyProgramBasicId}
                                search
                                fluid
                                selection
                                disabled={!this.state.academicYear || (this.state.orgUnitFilter && !this.state.orgUnit)}
                            />
                            </Form.Field>
                            <Form.Field />
                        </Form.Group>
                    </Segment>
                    <Button
                        basic="true"
                        color="blue"
                        floated="right"
                        onClick={this.props.closeReport}
                        disabled={!this.state.academicYear || (this.state.orgUnitFilter && !this.state.orgUnit)}
                    >
                        Odustani
                    </Button>
                    <Button
                        color="blue"
                        floated="right"
                        onClick={() => this.getData(this.state.studyProgramBasicId || 0)}
                        disabled={!this.state.academicYear || (this.state.orgUnitFilter && !this.state.orgUnit)}
                    >
                        Prikaži izvještaj
                    </Button>
                </Form>

                <br /><br /><br />

                {reportRequested && academicYear && <CourseExamsStatistic data={data} loader={loader} excelData={this.state.excelData} />}

            </div>
        );
    }
}

export default ConstReportsByAcademicYear;



// WEBPACK FOOTER //
// ./src/views/StudentService/Reports/ConstReports/ConstReportsByAcademicYear.js